import { toZonedTime } from "date-fns-tz";
import { useAtomValue } from "jotai";
import { Dialog as DialogPrimitive } from "radix-ui";
import { useTranslation } from "react-i18next";

import { ContactUsDialog } from "~/components/contact-us-dialog";
import { Alert, AlertDescription, AlertTitle } from "~/components/ui/alert";
import { ClockIcon } from "~/components/ui/icons/clock";
import type { OrderQuery } from "~/graphql/graphql-new.gen";
import { brandState } from "~/stores/brand";
import { formatDate } from "~/utils/date";

type OrderDelayAlertProps = {
  order?: OrderQuery["order"];
};

export const OrderDelayAlert: React.FC<OrderDelayAlertProps> = ({
  order,
}: OrderDelayAlertProps) => {
  const { i18n, t } = useTranslation();

  const brand = useAtomValue(brandState);

  if (
    order?.isShippingEstimatedTimeExceeded &&
    !order.parcels[0]?.trackingNumber &&
    !order.isFullDigital
  ) {
    return (
      <Alert appearance="error">
        <ClockIcon />
        <AlertTitle>
          {t("order.delayed")}{" "}
          {formatDate(
            brand?.timezone
              ? toZonedTime(new Date(order.createdAt), brand.timezone)
              : new Date(order.createdAt),
            i18n.language.replace("_", "-"),
            {
              day: "numeric",
              month: "long",
            },
          )}
          .
        </AlertTitle>
        <AlertDescription>
          {t("order.delayed_text")}{" "}
          <DialogPrimitive.Root modal={false}>
            <DialogPrimitive.Trigger asChild>
              <button type="button" className="font-semibold text-green-900">
                {t("order.contact_us")}
              </button>
            </DialogPrimitive.Trigger>
            <ContactUsDialog />
          </DialogPrimitive.Root>
        </AlertDescription>
      </Alert>
    );
  }

  return null;
};
